import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import "./Home.css";
import NavBar from "./common/NavBar";
import Header from "./common/Header";
import Footer from "./common/Footer";
import FooterMinified from "./common/FooterMinified";
import ImagesContainer from "./common/ImagesContainer";
import FrontVideo from "../assets/Furniture AA.mp4";
import AutoPlaySilentVideo from "./common/AutoPlaySilentVideo";

const Home = () => {
  const [textColor, setTextColor] = useState("white");
  const [isWhiteImage, setWhiteImage] = useState(true);
  const isDesktop = useMediaQuery({ minDeviceWidth: 821 });

  useEffect(() => {
    const handleScroll = () => {
      const videoElement = document.getElementById("video");
      const videoBottom =
        (videoElement as HTMLElement).getBoundingClientRect().bottom +
        window.scrollY;
      const scrollPosition = window.scrollY;
      if (scrollPosition > videoBottom) {
        setTextColor("black");
        setWhiteImage(false);
      } else {
        setTextColor("white");
        setWhiteImage(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div id="root">
      {isDesktop ? (
        <NavBar isWhiteImage={isWhiteImage} textColor={textColor}></NavBar>
      ) : (
        <Header
          isWhiteImage={isWhiteImage}
          textColor={textColor}
          bgColor="transparent"
        ></Header>
      )}
      <section id="video" className="video-section">
        <AutoPlaySilentVideo video={FrontVideo}></AutoPlaySilentVideo>
        <div className="video-title">
          <h1 className="title-bold">FALL 24</h1>
          <p className="highlight">HIGHLIGHT</p>
        </div>
      </section>

      <ImagesContainer></ImagesContainer>
      {isDesktop ? <Footer></Footer> : <FooterMinified></FooterMinified>}
    </div>
  );
};

export default Home;
